import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdfReader = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#1BCFC4" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.25 5.513v2.754c0 .373 0 .56.068.702.06.126.156.228.273.292.134.072.309.072.659.072h2.582m-3.582 6H9.5m5-2.666h-5m7.5-2.008v4.808c0 1.12 0 1.68-.204 2.108-.18.376-.467.682-.82.874-.4.218-.926.218-1.976.218h-4c-1.05 0-1.575 0-1.976-.218a1.94 1.94 0 0 1-.82-.874C7 17.147 7 16.587 7 15.467V8.533c0-1.12 0-1.68.204-2.108.18-.376.467-.682.82-.874.4-.218.926-.218 1.976-.218h2.007c.459 0 .688 0 .904.056q.288.075.542.239c.19.124.351.297.676.643l1.992 2.125c.325.346.487.519.603.72q.154.271.224.579c.052.23.052.475.052.964"
    />
  </svg>
);
export default SvgPdfReader;
